// Exception: HOC that proxy down props
/* eslint-disable react/jsx-props-no-spreading */

import { FC, SVGProps } from 'react';

import classes from './Image.module.scss';

const ResonatorsImage: FC<SVGProps<SVGSVGElement>> = props => (
  // View box is shifted to the left, so the chip is exactly in the center.
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-40 0 2000 2000" xmlSpace="preserve" {...props}>
    <path
      className={classes.st5}
      d="m1673.42 1075.49-712.91 411.6-709.15-409.43 712.91-411.6 709.15 409.43z"
    />
    <path
      className={classes.st0}
      d="M881.2 1422.29s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 880.323 1422.694)"
      className={classes.st0}
      cx="880.36"
      cy="1422.78"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M936.75 1390.22s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 935.868 1390.624)"
      className={classes.st0}
      cx="935.91"
      cy="1390.71"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M992.3 1358.15s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 991.416 1358.556)"
      className={classes.st0}
      cx="991.46"
      cy="1358.64"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1047.85 1326.08s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1046.963 1326.485)"
      className={classes.st0}
      cx="1047.01"
      cy="1326.57"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1103.4 1294s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1102.508 1294.417)"
      className={classes.st0}
      cx="1102.56"
      cy="1294.5"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1158.95 1261.93s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1158.056 1262.347)"
      className={classes.st0}
      cx="1158.11"
      cy="1262.43"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M819.17 1386.48s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 818.295 1386.888)"
      className={classes.st0}
      cx="818.33"
      cy="1386.97"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M874.72 1354.4s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 873.842 1354.817)"
      className={classes.st0}
      cx="873.88"
      cy="1354.9"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M930.27 1322.33s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 929.388 1322.749)"
      className={classes.st0}
      cx="929.43"
      cy="1322.83"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M985.82 1290.26s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 984.935 1290.668)"
      className={classes.st0}
      cx="984.98"
      cy="1290.75"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1041.36 1258.19s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1040.48 1258.6)"
      className={classes.st0}
      cx="1040.53"
      cy="1258.68"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1096.91 1226.12s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1096.028 1226.53)"
      className={classes.st0}
      cx="1096.08"
      cy="1226.61"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M756.88 1350.51s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 756.017 1350.93)"
      className={classes.st0}
      cx="756.05"
      cy="1351.01"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M812.43 1318.44s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 811.553 1318.86)"
      className={classes.st0}
      cx="811.59"
      cy="1318.94"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M867.98 1286.37s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 867.101 1286.78)"
      className={classes.st0}
      cx="867.14"
      cy="1286.86"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M923.53 1254.3s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 922.646 1254.712)"
      className={classes.st0}
      cx="922.69"
      cy="1254.79"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M979.08 1222.23s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 978.194 1222.642)"
      className={classes.st0}
      cx="978.24"
      cy="1222.72"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1034.63 1190.16s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1033.741 1190.572)"
      className={classes.st0}
      cx="1033.79"
      cy="1190.65"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M694.27 1314.37s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 693.41 1314.784)"
      className={classes.st0}
      cx="693.44"
      cy="1314.86"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M749.82 1282.3s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 748.956 1282.713)"
      className={classes.st0}
      cx="748.99"
      cy="1282.79"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M805.37 1250.22s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 804.503 1250.643)"
      className={classes.st0}
      cx="804.54"
      cy="1250.72"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M860.92 1218.15s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 860.04 1218.574)"
      className={classes.st0}
      cx="860.08"
      cy="1218.65"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M916.47 1186.08s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 915.585 1186.496)"
      className={classes.st0}
      cx="915.63"
      cy="1186.57"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M972.02 1154.01s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 971.133 1154.425)"
      className={classes.st0}
      cx="971.18"
      cy="1154.5"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M632.14 1278.49s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 631.273 1278.917)"
      className={classes.st0}
      cx="631.3"
      cy="1279"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M687.69 1246.42s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 686.818 1246.846)"
      className={classes.st0}
      cx="686.85"
      cy="1246.92"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M743.24 1214.35s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 742.366 1214.768)"
      className={classes.st0}
      cx="742.4"
      cy="1214.84"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M798.79 1182.28s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 797.911 1182.697)"
      className={classes.st0}
      cx="797.95"
      cy="1182.77"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M854.34 1150.21s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 853.459 1150.627)"
      className={classes.st0}
      cx="853.5"
      cy="1150.7"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M909.88 1118.14s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 909.006 1118.559)"
      className={classes.st0}
      cx="909.05"
      cy="1118.63"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M944.03 1458.57s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 943.16 1458.972)"
      className={classes.st0}
      cx="943.2"
      cy="1459.06"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M999.58 1426.49s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 998.706 1426.901)"
      className={classes.st0}
      cx="998.75"
      cy="1426.99"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1055.13 1394.42s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1054.253 1394.831)"
      className={classes.st0}
      cx="1054.3"
      cy="1394.92"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1110.68 1362.35s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1109.79 1362.752)"
      className={classes.st0}
      cx="1109.84"
      cy="1362.84"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1166.23 1330.28s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1165.336 1330.684)"
      className={classes.st0}
      cx="1165.39"
      cy="1330.77"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1221.78 1298.21s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1220.883 1298.613)"
      className={classes.st0}
      cx="1220.95"
      cy="1298.7"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M569.93 1242.58s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 569.064 1243)"
      className={classes.st0}
      cx="569.09"
      cy="1243.08"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M625.47 1210.5s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 624.611 1210.93)"
      className={classes.st0}
      cx="624.64"
      cy="1211"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M681.02 1178.43s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 680.157 1178.859)"
      className={classes.st0}
      cx="680.19"
      cy="1178.93"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M736.57 1146.36s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 735.705 1146.78)"
      className={classes.st0}
      cx="735.74"
      cy="1146.85"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M792.12 1114.29s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 791.25 1114.712)"
      className={classes.st0}
      cx="791.29"
      cy="1114.78"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M847.67 1082.22s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 846.797 1082.641)"
      className={classes.st0}
      cx="846.84"
      cy="1082.71"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M507.7 1206.65s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 506.836 1207.07)"
      className={classes.st0}
      cx="506.86"
      cy="1207.15"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M563.25 1174.58s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 562.384 1175.003)"
      className={classes.st0}
      cx="562.41"
      cy="1175.07"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M618.8 1142.51s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 617.93 1142.932)"
      className={classes.st0}
      cx="617.96"
      cy="1143"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M674.35 1110.43s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 673.477 1110.864)"
      className={classes.st0}
      cx="673.51"
      cy="1110.93"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M729.9 1078.36s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99L716 1058.47c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 729.024 1078.794)"
      className={classes.st0}
      cx="729.06"
      cy="1078.86"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M785.44 1046.29s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 784.572 1046.723)"
      className={classes.st0}
      cx="784.61"
      cy="1046.79"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M446.29 1171.2s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 445.44 1171.624)"
      className={classes.st0}
      cx="445.46"
      cy="1171.7"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M501.84 1139.13s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 500.985 1139.554)"
      className={classes.st0}
      cx="501.01"
      cy="1139.63"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M557.39 1107.05s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 556.532 1107.486)"
      className={classes.st0}
      cx="556.56"
      cy="1107.55"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M612.94 1074.98s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 612.08 1075.416)"
      className={classes.st0}
      cx="612.11"
      cy="1075.48"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M668.49 1042.91s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 667.625 1043.337)"
      className={classes.st0}
      cx="667.66"
      cy="1043.4"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M724.04 1010.84s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 723.162 1011.268)"
      className={classes.st0}
      cx="723.2"
      cy="1011.33"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1214.49 1229.86s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1213.601 1230.268)"
      className={classes.st0}
      cx="1213.66"
      cy="1230.35"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1270.04 1197.79s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1269.149 1198.198)"
      className={classes.st0}
      cx="1269.21"
      cy="1198.28"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1325.59 1165.72s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1324.696 1166.13)"
      className={classes.st0}
      cx="1324.76"
      cy="1166.21"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1381.14 1133.65s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1380.242 1134.059)"
      className={classes.st0}
      cx="1380.31"
      cy="1134.14"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1436.69 1101.58s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1435.79 1101.989)"
      className={classes.st0}
      cx="1435.86"
      cy="1102.06"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1492.24 1069.5s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1491.337 1069.92)"
      className={classes.st0}
      cx="1491.42"
      cy="1069.99"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1152.46 1194.05s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1151.576 1194.461)"
      className={classes.st0}
      cx="1151.63"
      cy="1194.54"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1208.01 1161.98s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1207.12 1162.39)"
      className={classes.st0}
      cx="1207.18"
      cy="1162.47"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1263.56 1129.9s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1262.668 1130.32)"
      className={classes.st0}
      cx="1262.73"
      cy="1130.4"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1319.11 1097.83s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1318.216 1098.252)"
      className={classes.st0}
      cx="1318.28"
      cy="1098.33"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1374.66 1065.76s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1373.761 1066.182)"
      className={classes.st0}
      cx="1373.83"
      cy="1066.26"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1430.21 1033.69s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1429.298 1034.103)"
      className={classes.st0}
      cx="1429.37"
      cy="1034.17"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1090.18 1158.09s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1089.287 1158.504)"
      className={classes.st0}
      cx="1089.34"
      cy="1158.58"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1145.72 1126.01s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1144.834 1126.433)"
      className={classes.st0}
      cx="1144.89"
      cy="1126.51"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1201.27 1093.94s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1200.382 1094.365)"
      className={classes.st0}
      cx="1200.44"
      cy="1094.44"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1256.82 1061.87s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1255.927 1062.284)"
      className={classes.st0}
      cx="1255.99"
      cy="1062.36"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1312.37 1029.8s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1311.475 1030.216)"
      className={classes.st0}
      cx="1311.54"
      cy="1030.29"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1367.92 997.73s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1367.02 998.145)"
      className={classes.st0}
      cx="1367.09"
      cy="998.21"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1027.57 1121.94s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1026.68 1122.357)"
      className={classes.st0}
      cx="1026.73"
      cy="1122.43"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1083.12 1089.87s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1082.226 1090.287)"
      className={classes.st0}
      cx="1082.28"
      cy="1090.36"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1138.67 1057.8s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1137.773 1058.216)"
      className={classes.st0}
      cx="1137.83"
      cy="1058.29"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1194.21 1025.72s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1193.32 1026.148)"
      className={classes.st0}
      cx="1193.38"
      cy="1026.22"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1249.76 993.65s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1248.866 994.078)"
      className={classes.st0}
      cx="1248.93"
      cy="994.15"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1305.31 961.58s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1304.413 962.01)"
      className={classes.st0}
      cx="1304.48"
      cy="962.08"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M965.43 1086.07s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 964.551 1086.488)"
      className={classes.st0}
      cx="964.6"
      cy="1086.56"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1020.98 1053.99s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1020.099 1054.42)"
      className={classes.st0}
      cx="1020.15"
      cy="1054.49"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1076.53 1021.92s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1075.646 1022.35)"
      className={classes.st0}
      cx="1075.7"
      cy="1022.42"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1132.08 989.85s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1131.192 990.28)"
      className={classes.st0}
      cx="1131.25"
      cy="990.35"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1187.63 957.78s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1186.74 958.2)"
      className={classes.st0}
      cx="1186.8"
      cy="958.27"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1243.18 925.71s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1242.276 926.132)"
      className={classes.st0}
      cx="1242.34"
      cy="926.2"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1277.33 1266.14s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1276.43 1266.545)"
      className={classes.st0}
      cx="1276.5"
      cy="1266.63"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1332.88 1234.07s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1331.976 1234.475)"
      className={classes.st0}
      cx="1332.05"
      cy="1234.56"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1388.42 1201.99s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1387.524 1202.407)"
      className={classes.st0}
      cx="1387.6"
      cy="1202.49"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1443.97 1169.92s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1443.071 1170.336)"
      className={classes.st0}
      cx="1443.15"
      cy="1170.42"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1499.52 1137.85s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1498.616 1138.266)"
      className={classes.st0}
      cx="1498.7"
      cy="1138.34"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1555.07 1105.78s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01"
    />
    <ellipse
      transform="rotate(-2.688 1554.162 1106.187)"
      className={classes.st0}
      cx="1554.25"
      cy="1106.26"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M903.22 1050.15s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 902.345 1050.571)"
      className={classes.st0}
      cx="902.39"
      cy="1050.64"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M958.77 1018.08s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 957.89 1018.503)"
      className={classes.st0}
      cx="957.94"
      cy="1018.57"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1014.32 986s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1013.427 986.434)"
      className={classes.st0}
      cx="1013.48"
      cy="986.5"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1069.87 953.93s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99L1049.13 938c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1068.974 954.364)"
      className={classes.st0}
      cx="1069.03"
      cy="954.43"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1125.42 921.86s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1124.522 922.294)"
      className={classes.st0}
      cx="1124.58"
      cy="922.36"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1180.97 889.79s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1180.067 890.215)"
      className={classes.st0}
      cx="1180.13"
      cy="890.28"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M840.99 1014.22s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 840.117 1014.645)"
      className={classes.st0}
      cx="840.16"
      cy="1014.71"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M896.54 982.15s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 895.662 982.576)"
      className={classes.st0}
      cx="895.71"
      cy="982.64"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M952.09 950.08s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 951.21 950.506)"
      className={classes.st0}
      cx="951.26"
      cy="950.57"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1007.64 918.01s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1006.757 918.436)"
      className={classes.st0}
      cx="1006.81"
      cy="918.5"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1063.19 885.94s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01s.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1062.303 886.367)"
      className={classes.st0}
      cx="1062.36"
      cy="886.43"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1118.74 853.86s.77-.44 1.71-.99.93-1.44-.02-1.99L1098 837.94c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1117.84 854.297)"
      className={classes.st0}
      cx="1117.9"
      cy="854.36"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M779.59 978.77s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01s1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 778.71 979.198)"
      className={classes.st0}
      cx="778.75"
      cy="979.26"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M835.14 946.7s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 834.255 947.128)"
      className={classes.st0}
      cx="834.3"
      cy="947.19"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M890.69 914.63s.77-.44 1.71-.99.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 889.802 915.06)"
      className={classes.st0}
      cx="889.85"
      cy="915.12"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M946.24 882.55s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 945.35 882.989)"
      className={classes.st0}
      cx="945.4"
      cy="883.05"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1001.79 850.48s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99s2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1000.895 850.92)"
      className={classes.st0}
      cx="1000.95"
      cy="850.98"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1057.33 818.41s.77-.44 1.71-.99c.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l22.43 12.95c.95.55 2.5.56 3.44.01.94-.54.93-1.44-.02-1.99l-22.43-12.95c-.95-.55-.96-1.44-.02-1.99.94-.54 2.49-.54 3.44.01l8.67 5.01c.95.55 2.5.56 3.44.01.94-.54 1.71-.99 1.71-.99"
    />
    <ellipse
      transform="rotate(-2.688 1056.443 818.85)"
      className={classes.st0}
      cx="1056.5"
      cy="818.91"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M458.57 1091.44s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99L450 1094.4c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 459.416 1090.888)"
      className={classes.st0}
      cx="459.44"
      cy="1090.96"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M514.12 1059.37s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 514.964 1058.818)"
      className={classes.st0}
      cx="514.99"
      cy="1058.88"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M569.67 1027.3s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99s-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 570.511 1026.75)"
      className={classes.st0}
      cx="570.54"
      cy="1026.81"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M625.22 995.23s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01L590.8 987.2c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 626.057 994.68)"
      className={classes.st0}
      cx="626.09"
      cy="994.74"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M680.77 963.16s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 681.604 962.611)"
      className={classes.st0}
      cx="681.64"
      cy="962.67"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M736.32 931.09s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99s-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 737.15 930.53)"
      className={classes.st0}
      cx="737.19"
      cy="930.59"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M396.69 1055.72s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 397.54 1055.162)"
      className={classes.st0}
      cx="397.55"
      cy="1055.23"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M452.24 1023.65s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99s-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 453.085 1023.092)"
      className={classes.st0}
      cx="453.1"
      cy="1023.15"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M507.79 991.58s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 508.633 991.021)"
      className={classes.st0}
      cx="508.66"
      cy="991.08"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M563.34 959.5s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 564.18 958.953)"
      className={classes.st0}
      cx="564.21"
      cy="959.01"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M618.89 927.43s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 619.726 926.883)"
      className={classes.st0}
      cx="619.76"
      cy="926.94"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M674.43 895.36s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 675.273 894.815)"
      className={classes.st0}
      cx="675.31"
      cy="894.87"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M791.86 899.02s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99s-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 792.697 898.462)"
      className={classes.st0}
      cx="792.74"
      cy="898.52"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M847.41 866.95s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01L813 858.92c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 848.245 866.392)"
      className={classes.st0}
      cx="848.29"
      cy="866.45"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M902.96 834.87s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 903.79 834.323)"
      className={classes.st0}
      cx="903.84"
      cy="834.38"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M958.51 802.8s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 959.337 802.253)"
      className={classes.st0}
      cx="959.39"
      cy="802.31"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1014.06 770.73s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 1014.885 770.183)"
      className={classes.st0}
      cx="1014.94"
      cy="770.24"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1069.61 738.66s-.77.44-1.71.99-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 1070.43 738.115)"
      className={classes.st0}
      cx="1070.49"
      cy="738.17"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M729.98 863.29s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 730.82 862.744)"
      className={classes.st0}
      cx="730.86"
      cy="862.8"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M785.53 831.22s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99s-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 786.366 830.665)"
      className={classes.st0}
      cx="786.41"
      cy="830.72"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M841.08 799.15s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99s-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99s-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 841.914 798.595)"
      className={classes.st0}
      cx="841.96"
      cy="798.65"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M896.63 767.08s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 897.459 766.527)"
      className={classes.st0}
      cx="897.51"
      cy="766.58"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M952.18 735s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01s-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 953.006 734.456)"
      className={classes.st0}
      cx="953.06"
      cy="734.51"
      rx="1.18"
      ry=".68"
    />
    <path
      className={classes.st0}
      d="M1007.73 702.93s-.77.44-1.71.99c-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l22.43 12.95c.95.55.96 1.44.02 1.99-.94.54-2.49.54-3.44-.01l-22.43-12.95c-.95-.55-2.5-.56-3.44-.01-.94.54-.93 1.44.02 1.99l8.67 5.01c.95.55.96 1.44.02 1.99-.94.54-1.71.99-1.71.99"
    />
    <ellipse
      transform="rotate(-2.688 1008.543 702.388)"
      className={classes.st0}
      cx="1008.6"
      cy="702.44"
      rx="1.18"
      ry=".68"
    />
  </svg>
);

export default ResonatorsImage;
